import { isPlainObject } from 'lodash'
import QueryString from 'qs'
import { apiClient } from '../client'
import { triggerDownload } from '../globalFunctions'
import { ExportListParams } from './types'

export const getDataForExport = async (params: ExportListParams, exportAllData: boolean, module: string) => {
    const response = await apiClient(exportAllData ? `v1/${module}?noLimit=1` : `v1/${module}`, {
        params,
        paramsSerializer: (params: ExportListParams) => {
            const criteria = isPlainObject(params.criteria) ? params.criteria : {}
            const paramsWithValidCriteria = { ...params, criteria }
            return QueryString.stringify(paramsWithValidCriteria)
        },
        // resolves to default timeout if exportAllData is false
        timeout: exportAllData ? 0 : undefined,
    })
    return response.data
}

export const checkGdprExport = async () => {
    const response = await apiClient('v1/gdpr-export?noLimit=1')

    return response.data
}

// does not return any data
export const generateGdprExport = async () => {
    await apiClient('v1/gdpr-export/export', { method: 'POST', timeout: 0 })
}

// does not return any data
export const cancelGdprExport = async (id: number) => {
    await apiClient(`v1/gdpr-export/cancel/${id}`, { method: 'PUT' })
}

// does not return any data
export const deleteGdprExport = async (id: number) => {
    await apiClient(`v1/gdpr-export/delete/${id}`, { method: 'DELETE' })
}

export const downloadGdprExport = async (id: number, fileName: string) => {
    const response = await apiClient(`v1/gdpr-export/download/${id}`, {
        method: 'GET',
        responseType: 'blob',
        timeout: 0,
    })

    const blob = response.data
    triggerDownload(id, blob, fileName)
}
